import { api } from "@/lib/axios";

const isPositiveId = (value: unknown): value is number =>
  typeof value === "number" && Number.isSafeInteger(value) && value > 0;

const normalizeIds = (values: readonly number[]): number[] => [
  ...new Set(values.filter(isPositiveId)),
];

const parseOrder = (value: unknown): number[] => {
  if (
    typeof value !== "object" ||
    value === null ||
    !("ordered_ids" in value) ||
    !Array.isArray(value.ordered_ids) ||
    !value.ordered_ids.every(isPositiveId) ||
    new Set(value.ordered_ids).size !== value.ordered_ids.length
  ) {
    throw new Error("Malformed navigation order response");
  }
  return value.ordered_ids;
};

export const navigationOrderApi = {
  getStudyGroups: async (): Promise<number[]> => {
    const response = await api.get("/navigation/order/spaces");
    return parseOrder(response.data);
  },

  saveStudyGroups: async (orderedIds: readonly number[]): Promise<number[]> => {
    const response = await api.put("/navigation/order/spaces", {
      ordered_ids: normalizeIds(orderedIds),
    });
    return parseOrder(response.data);
  },

  getChannels: async (spaceId: number): Promise<number[]> => {
    const response = await api.get("/navigation/order/channels", {
      params: { spaceId },
    });
    return parseOrder(response.data);
  },

  saveChannels: async (
    spaceId: number,
    orderedIds: readonly number[],
  ): Promise<number[]> => {
    const response = await api.put(
      "/navigation/order/channels",
      { ordered_ids: normalizeIds(orderedIds) },
      { params: { spaceId } },
    );
    return parseOrder(response.data);
  },
};
